<template>
  <div id="app">
    
    <!-- 路由视图容器 -->
    <main class="app-main">
      <!-- Vue Router 视图组件，用于显示当前路由对应的组件 -->
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
import { getDeviceByCode } from '@/util'
/**
 * App根组件
 * 包含应用程序的主要布局和路由导航
 */
export default {
  name: "app",
  
  /**
   * 组件挂载时的钩子函数
   */
  mounted() {
    console.log('App组件已挂载，路由功能已启用')
  }
};
</script>

<style>
/* App根组件样式 */
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}



/* 主内容区域样式 */
.app-main {
  flex: 1;
  overflow-x: hidden;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .nav-container {
    padding: 0 15px;
    height: 50px;
  }
  
  .nav-title {
    font-size: 1.5rem;
  }
  
  .nav-links {
    gap: 10px;
  }
  
  .nav-link {
    padding: 6px 12px;
    font-size: 14px;
  }
}

html {
  /* 设置根元素字体大小为 10px，这样 1rem = 10px，100px = 10rem */
  font-size: 10px;
  /* -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%; */
  -ms-text-size-adjust: none;
  -webkit-text-size-adjust: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -moz-tap-highlight-color: rgba(0, 0, 0, 0);
}

body {
  font-family: Helvetica, STHeiti STXihei, Microsoft JhengHei, Microsoft YaHei,
    Arial;
  margin: 0;
  background-color: #fff;
  height: 100%;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  margin: 0 auto;
  min-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue